// Administrator panel: AI costs of the whole app and the AI limits.
export default {
    ai: {
        forbidden: 'This panel is only for the administrator.',
        onlyAccount: 'Only the account: {account}',
        allAccounts: 'All accounts',
        unpriced: '{n} call without a known price (counted as 0) | {n} calls without a known price (counted as 0)',
        errorsShare: 'errors: {n}%',
        perAccount: 'Cost per active account',
        activeAccounts: '{n} active account | {n} active accounts',
        avgCall: 'Average per call',
        perDay: 'Cost per day',
        perDayAria: 'AI cost per day in the month, at most {max} on one day',
        callsN: '{n} call | {n} calls',
        limits: {
            title: 'AI limits',
            hint: 'Monthly cost caps in USD, counted from the 1st of the month. Empty = no limit. When used up, AI features refuse until the month ends (not for the administrator).',
            app: 'App AI limit',
            default: 'Default account AI limit',
            none: 'no limit',
            appUsed: 'This month: {spent} of {limit}',
            saved: 'Saved — applies at once.',
            failed: 'Could not save.',
        },
        accounts: {
            title: 'Accounts',
            hint: 'Cost in the chosen month; “now” is the current month, which the limit is checked against. Click an account to narrow the view.',
            hintPast: 'Cost in the chosen month; “now” is the current month, which the limit is checked against.',
            account: 'Account',
            limit: 'AI limit',
            now: 'Now',
            change: 'Change limit',
            filter: 'Show only this account',
            amount: 'Amount in USD',
            adminNoLimit: 'administrator — no limit',
            noLimit: 'no limit',
            own: 'own: {amount}',
            default: 'default: {amount}',
            defaultNone: 'default (no limit)',
            modes: {
                default: 'Default',
                custom: 'Own',
                none: 'No limit',
            },
        },
    },
};
